import { createSelector } from 'reselect'

export const selectTranscendState = state => state.transcend

export const selectIsTranscendInitialized = createSelector(selectTranscendState, state => {
  return state.isInitialized
})
